module.exports = __webpack_public_path__ + "img/aboutUs.a9cbcbde.png";